import { DISABLE_BUTTON, ENABLE_BUTTON } from "./types";

const initialState = {
    isButtonEnabled: false,
  };
  
  export const buttonReducer = (state = initialState, action) => {
    switch (action.type) {
      case ENABLE_BUTTON:
        return {
          ...state,
          isButtonEnabled: false,
        };
      case DISABLE_BUTTON:
        return {
          ...state,
          isButtonEnabled: true,
        };
      default:
        return state;
    }
  };
  